import { useState, useEffect, useRef } from 'react';
import { loadModules } from 'esri-loader';
import { esriOptions, loadMap } from '../../../util/map';
import { Gate } from '../../../schema/gate';
import { api } from '../../../api';
import { ZKDevice } from '../../../schema/zk_device';

interface EsriMapProps {
  gates?: Gate[];
}

const EsriMap: React.FC<EsriMapProps> = ({ gates }: EsriMapProps) => {
  const [mapView, setMapView] = useState<any>(null);
  const mapDiv = useRef(null);
  const graphicsLayerRef = useRef(null);
  const [devices, setDevices] = useState<any>({});

  useEffect(() => {
    api.get<ZKDevice[]>(`/bypass/zk_device`).then((res) => {
      const { data } = res;
      // setDevices(data);
      const temp_data: any = {};
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        temp_data[element.device_id] = element.device_status;
        if (i == data.length-1) {
          setDevices(temp_data);
        }
      }
    });
  }, []);
  useEffect(() => {
    const container = mapDiv.current;
    loadMap(container, 'streets-navigation-vector').then((view) => {
      setMapView(view); // hold on to the view for later
    });
  }, []);
  useEffect(() => {
    if (mapView != null) {
      loadModules(['esri/widgets/ScaleBar', 'esri/widgets/Legend'], esriOptions).then(
        ([ScaleBar, Legend]) => {
          const scalebar = new ScaleBar({
            view: mapView
          });
          mapView.ui.add(scalebar, 'bottom-left');
          const legend = new Legend({
            view: mapView
          });
          mapView.ui.add(legend, 'bottom-right');
        }
      );
    }
  }, [mapView]);

  useEffect(() => {
    if (mapView != null && gates && gates.length > 0 && Object.keys(devices).length > 0) {
      loadModules(['esri/Graphic', 'esri/layers/GraphicsLayer'], esriOptions).then(
        ([Graphic, GraphicsLayer]) => {
          mapView.map.remove(graphicsLayerRef.current);
          const graphicsLayer = new GraphicsLayer({
            view: mapView
          });
          mapView.map.add(graphicsLayer);

          gates.forEach((gate) => {
            const pointGraphicData = createGatepointGraphicData(gate, devices[gate.acc_device_id]);
            if (pointGraphicData) {
              const pointGraphic = new Graphic(pointGraphicData);
              graphicsLayer.add(pointGraphic);
            }
            
          });
          graphicsLayerRef.current = graphicsLayer;
        }
      );
    }
  }, [mapView, gates, devices]);

  return <div className="esri-map" ref={mapDiv} style={{ width: '100%', height: '100%' }} />;
};

export default EsriMap;

function createGatepointGraphicData(gate: Gate, device: any) {
  if (gate.lat && gate.long) {
    const point = {
      type: 'point', // autocasts as new Point()
      longitude: gate.long,
      latitude: gate.lat
    };
    const markerSymbol = {
      type: 'simple-marker', // autocasts as new SimpleMarkerSymbol()
      color: (gate.is_active == false ? [102, 102, 102] : (device == "1" ? [91, 194, 54] : [226, 119, 40])),
      size: '16px',
      outline: {
        color: [255, 255, 255],
        width: 1
      }
    };
    const popupTemplate = {
      title: 'Door : {Name}',
      content: '{Description}'
    };
    const attributes = {
      Name: gate.gate_name,
      Description: `Device name : ${gate.acc_device_name}\nDevice ID : ${gate.acc_device_id}\nStatus : ${(device == "1" ? "ออนไลน์" : (device == "0" ? "ขาดการเชื่อมต่อ" : "ปิดการใช้งาน"))}`
    };
    return {
      geometry: point,
      symbol: markerSymbol,
      attributes: attributes,
      popupTemplate: popupTemplate
    };
  }
  return null;
}
